import { BROKER_LINKS } from "@/data/brokers";

export default function BrokerSection() {
  return (
    <section className="flex flex-col items-center">
      {/* Top header */}
      <div className="text-center">
        <span className="mb-3 inline-block text-xs font-bold uppercase tracking-widest text-purple-600">
          ĐÁNH GIÁ SÀN GIAO DỊCH
        </span>
        <h2 className="text-4xl font-extrabold text-slate-900">
          Tìm hiểu các nhà môi giới hàng đầu
        </h2>
        <p className="mx-auto mt-3 max-w-xl leading-relaxed text-slate-500">
          Thông tin tham khảo khách quan về các nhà môi giới phổ biến, giúp bạn tối ưu hóa chi phí giao dịch.
        </p>
      </div>

      {/* Cards grid */}
      <div className="mt-12 grid w-full grid-cols-1 gap-8 md:grid-cols-3">
        {/* Card 1 — IC Markets */}
        <div className="flex flex-col justify-between rounded-3xl border border-slate-200/80 bg-white p-8 shadow-sm transition-all hover:shadow-md">
          <div>
            <div className="mb-6 flex items-center gap-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-900 text-lg font-black text-white shadow-sm">
                IC
              </span>
              <div>
                <p className="text-xl font-extrabold text-slate-900">IC Markets</p>
                <p className="mt-0.5 text-xs text-slate-400">MetaTrader 4/5 · cTrader</p>
              </div>
            </div>

            <div className="mb-8 flex flex-col gap-3 rounded-2xl bg-slate-50 p-4">
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Spread</span>
                <span className="font-bold text-slate-900">từ 0.0 pip</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Đòn bẩy</span>
                <span className="font-bold text-slate-900">1:500</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Quản lý</span>
                <span className="text-xs font-semibold text-purple-600">ASIC · CySEC</span>
              </div>
            </div>
          </div>

          <a
          
          
          href={BROKER_LINKS['IC Markets']}
            className="block w-full whitespace-nowrap rounded-xl border-2 border-purple-600 bg-white py-3.5 text-center text-sm font-bold text-purple-600 shadow-sm transition-all hover:bg-purple-50"
          >
            Mở tài khoản ngay →
          </a>
        </div>

        {/* Card 2 — FxPro (Featured) */}
        <div className="relative flex flex-col justify-between rounded-3xl border-2 border-purple-600 bg-white p-8 shadow-xl shadow-purple-500/5 md:-translate-y-2">
          <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-purple-600 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white shadow-sm">
            🔥 Khuyên dùng
          </span>

          <div>
            <div className="mb-6 mt-1 flex items-center gap-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-purple-600 text-lg font-black text-white shadow-md shadow-purple-500/20">
                FP
              </span>
              <div>
                <p className="text-xl font-extrabold text-slate-900">FxPro</p>
                <p className="mt-0.5 text-xs text-slate-400">MetaTrader 4/5 · WebTerminal</p>
              </div>
            </div>

            <div className="mb-8 flex flex-col gap-3 rounded-2xl border border-purple-100 bg-purple-50/50 p-4">
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Spread</span>
                <span className="font-black text-purple-600">từ 0.0 pip</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Đòn bẩy</span>
                <span className="font-bold text-purple-600">1:500</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Quản lý</span>
                <span className="text-xs font-semibold text-purple-600">FCA · CySEC · FSCA</span>
              </div>
            </div>
          </div>

          <a
          
          href={BROKER_LINKS['FxPro']}
            className="block w-full whitespace-nowrap rounded-xl bg-purple-600 py-3.5 text-center text-sm font-bold text-white shadow-md shadow-purple-600/20 transition-all hover:bg-purple-700"
          >
            Mở tài khoản ngay →
          </a>
        </div>

        {/* Card 3 — XM */}
        <div className="flex flex-col justify-between rounded-3xl border border-slate-200/80 bg-white p-8 shadow-sm transition-all hover:shadow-md">
          <div>
            <div className="mb-6 flex items-center gap-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-800 text-lg font-black text-white shadow-sm">
                XM
              </span>
              <div>
                <p className="text-xl font-extrabold text-slate-900">XM</p>
                <p className="mt-0.5 text-xs text-slate-400">MetaTrader 4 / 5</p>
              </div>
            </div>

            <div className="mb-8 flex flex-col gap-3 rounded-2xl bg-slate-50 p-4">
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Spread</span>
                <span className="font-bold text-slate-900">từ 0.6 pip</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Đòn bẩy</span>
                <span className="font-bold text-slate-900">1:1000</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Quản lý</span>
                <span className="text-xs font-semibold text-purple-600">ASIC · CySEC · FSC</span>
              </div>
            </div>
          </div>

          <a
          
          
          href={BROKER_LINKS['XM']}
            className="block w-full whitespace-nowrap rounded-xl border-2 border-purple-600 bg-white py-3.5 text-center text-sm font-bold text-purple-600 shadow-sm transition-all hover:bg-purple-50"
          >
            Mở tài khoản ngay →
          </a>
        </div>
      </div>

      {/* Disclaimer */}
      <p className="mx-auto mt-12 max-w-3xl text-center text-xs leading-relaxed text-slate-400">
        Công cụ này chỉ nhằm mục đích cung cấp thông tin và tính toán tham khảo. Kết quả có thể thay đổi tùy thuộc
        vào giá thị trường, loại sản phẩm và điều kiện giao dịch.
      </p>
    </section>
  );
}